export function isPaidEventCost(cost) {
  return cost?.type === "paid" && Number(cost?.amount) > 0;
}

export function isFreeEventCost(cost) {
  return !isPaidEventCost(cost);
}

export function formatEventCost(cost) {
  if (typeof cost === "string") {
    return cost.trim() || "See details";
  }

  if (!cost || cost.type === "free") {
    return "Free";
  }

  if (cost.type === "custom") {
    return String(cost.label || "").trim() || "See details";
  }

  if (cost.type === "paid" && Number(cost.amount) > 0) {
    return `$${cost.amount}`;
  }

  return "See details";
}
